import './src/styles/global.css';
import './src/localization/i18n';
import React, { useEffect } from 'react';
import { SnackbarProvider } from 'notistack';
import NotificationProvider from './src/components/root/notification';
import { THEME_GREEN } from './src/constants/style';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { I18nextProvider, useTranslation } from 'react-i18next';
import { isWeb } from './src/utilities/platform';

const theme = createTheme({
  palette: {
    primary: {
      main: THEME_GREEN,
    },
  },
});

const LocalizationProvider = ({ children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (isWeb && localStorage.LANG) i18n.changeLanguage(localStorage.LANG);
    else {
      i18n.changeLanguage('en-AU');
      localStorage.LANG = 'en-AU';
    }
  }, []);

  return (<I18nextProvider i18n={i18n}>{children}</I18nextProvider>)
};

export const wrapRootElement = ({ element, props }) => {
  return (
    <SnackbarProvider>
      <NotificationProvider>
        <ThemeProvider theme={theme}>
          <LocalizationProvider>{element}</LocalizationProvider>
        </ThemeProvider>
      </NotificationProvider>
    </SnackbarProvider>
  );
};